import getAPIResponse from "Shared/Utils/Domain/Services/GetAPIResponsePrivateService";
import { Document } from "../Model/Document";

export async function deleteDocument(id) {
    let response = await getAPIResponse("/v1/document/delete/"+id, {} , "DELETE");
    if (response === null) {
        return null;
    }
    let document = Document.createFromResponseData(response);
    return document;
}